import { Chip, Stack, Typography } from "@mui/material";

import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { pick } from "../managementDashboardUtils";

const EVENT_LABELS = {
  Created: "ایجاد",
  Assigned: "تخصیص",
  StatusChanged: "تغییر وضعیت",
  Completed: "تکمیل",
  PriorityChanged: "تغییر اولویت",
  DueDateChanged: "تغییر مهلت",
};

const ActionHistoryTimeline = ({ loading, error, data, onRetry }) => {
  const items = data?.items || data?.Items || [];
  const title = pick(data, "actionTitle", "ActionTitle");

  return (
    <ManagementWidgetShell
      title={title ? `تاریخچه: ${title}` : "تاریخچه اقدام"}
      subheader="ردیابی ایجاد، تخصیص، وضعیت و تکمیل"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Stack spacing={1.25}>
        {items.map((log) => {
          const eventType = pick(log, "eventType", "EventType");
          const changedAt = pick(log, "changedAt", "ChangedAt");
          return (
            <Stack
              key={pick(log, "id", "Id")}
              spacing={0.25}
              sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 1 }}
            >
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                <Chip size="small" label={EVENT_LABELS[eventType] || eventType} />
                <Typography variant="caption" color="text.secondary">
                  {changedAt ? new Date(changedAt).toLocaleString("fa-IR") : "—"}
                </Typography>
                <Typography variant="caption">
                  {pick(log, "changedByUserName", "ChangedByUserName")}
                </Typography>
              </Stack>
              <Typography fontSize={13}>{pick(log, "summary", "Summary")}</Typography>
              {(pick(log, "oldValue", "OldValue") || pick(log, "newValue", "NewValue")) ? (
                <Typography variant="caption" color="text.secondary">
                  {pick(log, "oldValue", "OldValue") || "—"}
                  {" → "}
                  {pick(log, "newValue", "NewValue") || "—"}
                </Typography>
              ) : null}
            </Stack>
          );
        })}
        {!items.length && !loading && !error ? (
          <Typography color="text.secondary">رویدادی ثبت نشده است.</Typography>
        ) : null}
      </Stack>
    </ManagementWidgetShell>
  );
};

export default ActionHistoryTimeline;
